import React from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import Success from 'components/shared/Success';
import Api from 'api';
import PATHS from 'constants/paths';
import AddReview from '../components/Add';
import { postReviewRequest } from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

const ReviewsAddContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { cottageId, bookingId } = useParams();
  const [canLeaveReview, setCanLeaveReview] = React.useState(false);
  const [alreadyReviewed, setAlreadyReviewed] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  const error = useSelector(selectors.error);
  const isUpdating = useSelector(selectors.isUpdating);
  const success = useSelector(selectors.success);

  const checkIfCanSendReview = async () => {
    try {
      const data = await Api.canSendReview(cottageId, bookingId);

      setCanLeaveReview(data.allowed);
      setAlreadyReviewed(!!data.reviewed);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    checkIfCanSendReview();
  }, []);

  const sendReview = (data) => {
    dispatch(
      postReviewRequest({
        data: {
          ...data,
          cottage_id: cottageId,
          booking_id: bookingId || null,
        },
      }),
    );
  };

  const { stars } = qs.parse(location.search);

  return (
    <Main
      title={
        <div>
          <IconButton color="inherit" component={Link} to={PATHS.reviews.root}>
            <ArrowBack />
          </IconButton>
          <FormattedMessage id="Add Review" defaultMessage="Add Review" />
        </div>
      }
    >
      <AddReview
        isLoading={isLoading}
        isUpdating={isUpdating}
        sendReview={sendReview}
        cottageId={cottageId}
        canLeaveReview={canLeaveReview}
        alreadyReviewed={alreadyReviewed}
        initialStars={stars}
      />
      <Success success={success} />
      <Errors errors={error} />
    </Main>
  );
};

export default ReviewsAddContainer;
